import { HEEDIFY_PROVIONONG_PATH_V2, TEXT_TO_SPEECH   } from "../Config/Config";
import axios from "axios";

const getHeaders = (token, isMultipart = false) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
});

// ------------------ LICENSES ------------------
export async function getAllLicences(tenantId, token, scope) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/LicencesManagement/${tenantId}/${scope}/get?token=${token}`;

    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

// ------------------ ROLES ------------------
export async function getAllRoles(tenant, token) {
  if (!tenant || !token) throw new Error("Tenant and token are required");
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/RolesManagement/${tenant}/get/ALL`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data?.success ? response.data.roles : {};
  } catch (e) {
    return {};
  }
}

// ------------------ PERMISSIONS ------------------
export async function getAllPermissions(tenantId, token) {
  try {

    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/Permissions/${tenantId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    if (response.data?.success) {
      return {
        userId: response.data.userId,
        tenant: response.data.tenant,
        scopes: response.data.scopes,
        roles: response.data.roles,
      };
    }
    return { scopes: {}, roles: {} };
  } catch (e) {
    return { scopes: {}, roles: {} };
  }
}

// ------------------ PARTNER TENANTS ------------------
export async function getPartnerTenants(tenantId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/partnerTenantsManagement/${tenantId}/get/ALL?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });

    if (response.data?.success) {
      // Nouvelle structure: { myTenant: {...}, tenants: [...] }
      return response.data.data || { myTenant: null, tenants: [] };
    }
    return { myTenant: null, tenants: [] };
  } catch (e) {
    return { myTenant: null, tenants: [] };
  }
}

// ------------------ MEDIA ------------------
export async function getAllMedia(tenantId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AudioManagement/${tenantId}/default/get/All?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function deleteMedia(tenantId, mediaName, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AudioManagement/${tenantId}/default/delete/${mediaName}?token=${token}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function uploadMedia(tenantId, userId, file, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/UploadMedia/${tenantId}/default/?userid=${userId}&filename=${file.name}`;
    const formData = new FormData();
    formData.append("File", file);
    const response = await axios.post(url, formData, { headers: getHeaders(token, true) });
    return response.data;
  } catch (e) {
    return null;
  }
}

// ------------------ AGENTS ------------------
export async function AddAgent(tenantId, userId, scope, agent, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentManagement/${tenantId}/${scope}/add/agent?userid=${userId}`;
    const response = await axios.post(url, { agent }, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function UpdateAgent(tenantId, userId, agentId, scope, agent, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentManagement/${tenantId}/${scope}/update/${agentId}?userid=${userId}`;
    const response = await axios.post(url, { agent }, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function DeleteAgent(tenantId, userId, agentId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentManagement/${tenantId}/${scope}/remove/${agentId}?userid=${userId}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (error) {
    console.error("❌ Error deleting agent:", error.response?.data || error.message);
    return {
      success: false,
      message: error.response?.data?.message || error.message || "Failed to delete agent"
    };
  }
}

export async function GetAgent(tenantId, userId, agentId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentManagement/${tenantId}/default/get/${agentId}?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function GetAllAgent(tenantId, userId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentManagement/${tenantId}/${scope}/get/ALL?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

// ------------------ AGENT PROFILES ------------------
export async function AddAgentProfile(tenantId, agentProfile, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentProfilesManagement/${tenantId}/add/NULL`;
    const response = await axios.post(url, agentProfile, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function UpdateAgentProfile(tenantId, agentProfileId, agentProfile, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentProfilesManagement/${tenantId}/update/${agentProfileId}`;
    const response = await axios.post(url, agentProfile, { headers: getHeaders(token) });

    return response.data;
  } catch (e) {
    return null;
  }
}

export async function DeleteAgentProfile(tenantId, agentProfileId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentProfilesManagement/${tenantId}/remove/${agentProfileId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });

    return response.data;
  } catch (e) {
    return null;
  }
}

export async function GetAllAgentProfile(tenantId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentProfilesManagement/${tenantId}/get/ALL`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function GetAgentProfile(tenantId, agentProfileId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentProfilesManagement/${tenantId}/get/${agentProfileId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

// ------------------ ANALYTICS PROFILES ------------------
export async function AddAnalyticsProfile(tenantId, analyticsProfile, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AnalyticsProfileManagement/${tenantId}/add/NULL`;
    const response = await axios.post(url, analyticsProfile, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function UpdateAnalyticsProfile(tenantId, analyticsProfileId, analyticsProfile, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AnalyticsProfileManagement/${tenantId}/update/${analyticsProfileId}`;
    const response = await axios.post(url, analyticsProfile, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function DeleteAnalyticsProfile(tenantId, analyticsProfileId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AnalyticsProfileManagement/${tenantId}/remove/${analyticsProfileId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function GetAllAnalyticsProfiles(tenantId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AnalyticsProfileManagement/${tenantId}/get/ALL`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function GetAnalyticsProfile(tenantId, analyticsProfileId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AnalyticsProfileManagement/${tenantId}/get/${analyticsProfileId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    console.log("✅ Analytics profile retrieved successfully:", response.data);
    return response.data;
  } catch (e) {
    return null;
  }
}

// ------------------ CALLFLOW ------------------
export async function GetCallFlow(tenantId, userId, CallFlowId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CallFlowManagement/${tenantId}/${scope}/get/${CallFlowId}?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function AddCallFlow(tenantId, userId, scope, token, callFlow) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CallFlowManagement/${tenantId}/${scope}/add/null?userid=${userId}`;
    const response = await axios.post(url, { callFlow }, { headers: getHeaders(token) });
    console.log("✅ Call flow added successfully:", response.data);
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function UpdateCallFlow(tenantId, userId, CallFlowId, scope, token, callFlow) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CallFlowManagement/${tenantId}/${scope}/update/${CallFlowId}?userid=${userId}`;
    const response = await axios.post(url, { callFlow }, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function DeleteCallFlow(tenantId, userId, CallFlowId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CallFlowManagement/${tenantId}/${scope}/remove/${CallFlowId}?userid=${userId}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function GetAllCallFlow(tenantId, userId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CallFlowManagement/${tenantId}/${scope}/get/ALL?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

// ------------------ IA AGENT ------------------
// Dedicated IaAgentManagement endpoint (mirrors CallFlowManagement).
// Backend stores iaAgents in the "Flows" Cosmos container with type="iaAgent"
// and filters by type — no client-side filtering needed anymore.
const IA_AGENT_TYPE = "iaAgent";

// Pretty console separator for visibility in dev console
const IA_SEP = "════════════════════════════════════════════════════════════";

export async function GetIaAgent(tenantId, userId, iaAgentId, scope, token) {
  const url = `${HEEDIFY_PROVIONONG_PATH_V2}/IaAgentManagement/${tenantId}/${scope}/get/${iaAgentId}?userid=${userId}`;
  console.log(`\n${IA_SEP}\n🤖 [IA_AGENT] → GET IaAgent\n${IA_SEP}`);
  console.log(`   URL      : ${url}`);
  console.log(`   tenantId : ${tenantId}`);
  console.log(`   scope    : ${scope}`);
  console.log(`   agentId  : ${iaAgentId}`);
  const t0 = performance.now();
  try {
    const response = await axios.get(url, { headers: getHeaders(token) });
    console.log(`✅ [IA_AGENT] ← GET IaAgent OK (${Math.round(performance.now() - t0)}ms) status=${response.status}`);
    console.log(`   doc.id   : ${response.data?.id}`);
    console.log(`   doc.type : ${response.data?.type}`);
    console.log(`${IA_SEP}\n`);
    return response.data;
  } catch (e) {
    console.error(`❌ [IA_AGENT] ← GET IaAgent FAIL (${Math.round(performance.now() - t0)}ms) status=${e.response?.status}`, e.response?.data || e.message);
    console.error(`${IA_SEP}\n`);
    return null;
  }
}

export async function AddIaAgent(tenantId, userId, scope, token, iaAgent) {
  const payload = { ...iaAgent, type: IA_AGENT_TYPE };
  const url = `${HEEDIFY_PROVIONONG_PATH_V2}/IaAgentManagement/${tenantId}/${scope}/add/null?userid=${userId}`;
  console.log(`\n${IA_SEP}\n🤖 [IA_AGENT] → ADD IaAgent\n${IA_SEP}`);
  console.log(`   URL      : ${url}`);
  console.log(`   tenantId : ${tenantId}`);
  console.log(`   scope    : ${scope}`);
  console.log(`   agentId  : ${payload.id}`);
  console.log(`   name     : ${payload.displayName || payload.agentPersonality?.name}`);
  const t0 = performance.now();
  try {
    const response = await axios.post(url, { iaAgent: payload }, { headers: getHeaders(token) });
    console.log(`✅ [IA_AGENT] ← ADD IaAgent OK (${Math.round(performance.now() - t0)}ms) status=${response.status}`);
    console.log(`   response :`, response.data);
    console.log(`${IA_SEP}\n`);
    return response.data;
  } catch (e) {
    console.error(`❌ [IA_AGENT] ← ADD IaAgent FAIL (${Math.round(performance.now() - t0)}ms) status=${e.response?.status}`, e.response?.data || e.message);
    console.error(`${IA_SEP}\n`);
    throw e;
  }
}

export async function UpdateIaAgent(tenantId, userId, iaAgentId, scope, token, iaAgent) {
  const payload = { ...iaAgent, type: IA_AGENT_TYPE };
  const url = `${HEEDIFY_PROVIONONG_PATH_V2}/IaAgentManagement/${tenantId}/${scope}/update/${iaAgentId}?userid=${userId}`;
  console.log(`\n${IA_SEP}\n🤖 [IA_AGENT] → UPDATE IaAgent\n${IA_SEP}`);
  console.log(`   URL      : ${url}`);
  console.log(`   tenantId : ${tenantId}`);
  console.log(`   scope    : ${scope}`);
  console.log(`   agentId  : ${iaAgentId}`);
  console.log(`   name     : ${payload.displayName || payload.agentPersonality?.name}`);
  const t0 = performance.now();
  try {
    const response = await axios.post(url, { iaAgent: payload }, { headers: getHeaders(token) });
    console.log(`✅ [IA_AGENT] ← UPDATE IaAgent OK (${Math.round(performance.now() - t0)}ms) status=${response.status}`);
    console.log(`   response :`, response.data);
    console.log(`${IA_SEP}\n`);
    return response.data;
  } catch (e) {
    console.error(`❌ [IA_AGENT] ← UPDATE IaAgent FAIL (${Math.round(performance.now() - t0)}ms) status=${e.response?.status}`, e.response?.data || e.message);
    console.error(`${IA_SEP}\n`);
    throw e;
  }
}

export async function DeleteIaAgent(tenantId, userId, iaAgentId, scope, token) {
  const url = `${HEEDIFY_PROVIONONG_PATH_V2}/IaAgentManagement/${tenantId}/${scope}/remove/${iaAgentId}?userid=${userId}`;
  console.log(`\n${IA_SEP}\n🤖 [IA_AGENT] → DELETE IaAgent\n${IA_SEP}`);
  console.log(`   URL      : ${url}`);
  console.log(`   tenantId : ${tenantId}`);
  console.log(`   scope    : ${scope}`);
  console.log(`   agentId  : ${iaAgentId}`);
  const t0 = performance.now();
  try {
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    console.log(`✅ [IA_AGENT] ← DELETE IaAgent OK (${Math.round(performance.now() - t0)}ms) status=${response.status}`);
    console.log(`   response :`, response.data);
    console.log(`${IA_SEP}\n`);
    return response.data;
  } catch (e) {
    console.error(`❌ [IA_AGENT] ← DELETE IaAgent FAIL (${Math.round(performance.now() - t0)}ms) status=${e.response?.status}`, e.response?.data || e.message);
    console.error(`${IA_SEP}\n`);
    throw e;
  }
}

export async function GetAllIaAgent(tenantId, userId, scope, token) {
  const url = `${HEEDIFY_PROVIONONG_PATH_V2}/IaAgentManagement/${tenantId}/${scope}/get/ALL?userid=${userId}`;
  console.log(`\n${IA_SEP}\n🤖 [IA_AGENT] → GET ALL IaAgents\n${IA_SEP}`);
  console.log(`   URL      : ${url}`);
  console.log(`   tenantId : ${tenantId}`);
  console.log(`   scope    : ${scope}`);
  const t0 = performance.now();
  try {
    const response = await axios.get(url, { headers: getHeaders(token) });
    const data = response.data;
    const normalized = Array.isArray(data)
      ? data
      : (data && typeof data === "object" ? Object.values(data) : []);
    console.log(`✅ [IA_AGENT] ← GET ALL IaAgents OK (${Math.round(performance.now() - t0)}ms) status=${response.status}`);
    console.log(`   count    : ${normalized.length}`);
    if (normalized.length > 0) {
      console.log(`   ids      :`, normalized.map(d => d.id));
      console.log(`   types    :`, [...new Set(normalized.map(d => d.type))]);
    } else {
      console.warn(`   ⚠️  Empty array — check backend filter and deployment`);
    }
    console.log(`${IA_SEP}\n`);
    return normalized;
  } catch (e) {
    console.error(`❌ [IA_AGENT] ← GET ALL IaAgents FAIL (${Math.round(performance.now() - t0)}ms) status=${e.response?.status}`, e.response?.data || e.message);
    console.error(`${IA_SEP}\n`);
    return [];
  }
}

// ------------------ CHATFLOW ------------------
export async function GetChatFlow(tenantId, userId, chatFlowId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChatFlowManagement/${tenantId}/${scope}/get/${chatFlowId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function AddChatFlow(tenantId, userId, scope, token, chatFlow) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChatFlowManagement/${tenantId}/${scope}/add/${chatFlow.id}?token=${token}`;
    const response = await axios.post(url, chatFlow, { headers: getHeaders(token) });
    // Retourner la réponse complète avec success et chatFlow
    return response.data;
  } catch (e) {
    return { success: false, message: e?.response?.data?.message || e.message };
  }
}

export async function UpdateChatFlow(tenantId, userId, chatFlowId, scope, token, chatFlow) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChatFlowManagement/${tenantId}/${scope}/update/${chatFlowId}?token=${token}`;
    const response = await axios.post(url, chatFlow, { headers: getHeaders(token) });
    // Retourner la réponse complète avec success et chatFlow
    return response.data;
  } catch (e) {
    return { success: false, message: e?.response?.data?.message || e.message };
  }
}

export async function DeleteChatFlow(tenantId, userId, chatFlowId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChatFlowManagement/${tenantId}/${scope}/delete/${chatFlowId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function GetAllChatFlow(tenantId, userId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChatFlowManagement/${tenantId}/${scope}/get/ALL?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function getChatFlowChannel(tenantId, scope, flowId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChannelManagement/${tenantId}/${scope}/${flowId}/get/ALL?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function unAssigneChannel(tenantId, scope, flowId, channelId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChannelManagement/${tenantId}/${scope}/${flowId}/unAssigneChannel/${channelId}?token=${token}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function assigneChannel(tenantId, scope, flowId, channelId, token, payload) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ChannelManagement/${tenantId}/${scope}/${flowId}/assigneChannel/${channelId}?token=${token}`;
    const response = await axios.post(url, payload, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

// ------------------ QUEUES ------------------
export async function getAllQueue(tenantId, userId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/QueueManagement/${tenantId}/${scope}/get/ALL?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function GetQueue(tenantId, userId, queueId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/QueueManagement/${tenantId}/${scope}/get/${queueId}?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function AddQueue(tenantId, userId, scope, queue, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/QueueManagement/${tenantId}/${scope}/add/queue?userid=${userId}`;
    const response = await axios.post(url, { queue }, { headers: getHeaders(token) });
    return response;
  } catch (e) {
    return { data: null, status: 500 };
  }
}

export async function UpdateQueue(tenantId, userId, queueId, scope, queue, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/QueueManagement/${tenantId}/${scope}/update/${queueId}?userid=${userId}`;
    const response = await axios.post(url, { queue }, { headers: getHeaders(token) });
    return response;
  } catch (e) {
    return { data: null, status: 500 };
  }
}

export async function DeleteQueue(tenantId, userId, queueId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/QueueManagement/${tenantId}/${scope}/remove/${queueId}?userid=${userId}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}
// ------------------ GROUPS ------------------
export async function getAllGroups(tenantId, scope, userId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/GroupManagement/${tenantId}/${scope}/get/ALL?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function GetGroup(tenantId, scope, groupId, userId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/GroupManagement/${tenantId}/${scope}/get/${groupId}?userid=${userId}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function AddGroup(tenantId, scope, userId, group, token) {
  try {

    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/GroupManagement/${tenantId}/${scope}/create/null?userid=${userId}`;
    const response = await axios.post(url, group, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function UpdateGroup(tenantId, scope, userId, groupId, group, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/GroupManagement/${tenantId}/${scope}/update/${groupId}?userid=${userId}`;
    const response = await axios.post(url, group, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function DeleteGroup(tenantId, scope, groupId, userId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/GroupManagement/${tenantId}/${scope}/remove/${groupId}?userid=${userId}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

// ------------------ AUDIO GENERATION ------------------
export const generateAudioService = async (data) => {
  try {
    const response = await axios.post(TEXT_TO_SPEECH, data);
    const url = decodeURIComponent(response.data.url);
    return url;
  } catch (e) {
    return null;
  }
};

// ------------------ SCOPES ------------------
export async function getScopeById(tenantId, scopeId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ScopeManagement/${tenantId}/get/${scopeId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });

    // Vérifier si la réponse a un wrapper success/data
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function getAllScopes(tenantId, token) {

  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ScopeManagement/${tenantId}/get/ALL?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
   
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function addScope(tenantId, token, scope) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ScopeManagement/${tenantId}/add`;
    const response = await axios.post(url, scope, { headers: getHeaders(token) });
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateScope(tenantId, scopeId, token, scope) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ScopeManagement/${tenantId}/update/${scopeId}`;
    const response = await axios.post(url, scope, { headers: getHeaders(token) });
    return response;
  } catch (e) {
    return null;
  }
}

export async function deleteScope(tenantId, scopeId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ScopeManagement/${tenantId}/remove/${scopeId}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response;
  } catch (e) {
    return null;
  }
}

// ------------------ CONSENT ------------------
export function getAdminConsentUrl(clientId, redirectUri) {
  const baseConsentUrl = "https://login.microsoftonline.com/common/adminconsent?client_id=";
  return `${baseConsentUrl}${clientId}&redirect_uri=${redirectUri}`;
}

export async function checkConsentStatusApi(tenantId, userId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CheckAppConsent/${tenantId}/getConsent`;
    const response = await axios.post(url, {
      tenantId: tenantId,
      userId: userId,
    }, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    return null;
  }
}

export async function registerConsentApi(tenantId, userId, clientId, token) {
  try {
    console.log("AB#820 Registering consent with tenantId:", tenantId, "userId:", userId, "clientId:", clientId, "token:", token ? "present" : "missing");
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AppConsent/${tenantId}/add/${clientId}/${userId}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    console.log("AB#820 Consent registered successfully:", response.data);
    return response.data;
  } catch (e) {
    console.error("AB#820 Error registering consent:", e);
    return null;
  }
}

// ------------------ RECORDINGS ------------------
// Service to retrieve call recording info
export const retrieveCallRecordingInfo = (tenantId, filters) => {
  return new Promise((resolve) => {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/ManageRecordedCallCDR/${tenantId}/get`;
    axios.post(url, { filters })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        resolve();
      });
  });
};

// Service to retrieve call recording URL
export const retrieveCallRecordingUrl = (tenantId, recordingScopeId, callId) => {
  return new Promise((resolve) => {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/BlobSasGenerator/${tenantId}/${recordingScopeId}/${callId}`;
    axios.get(url)
      .then((response) => {
        if (response.data && response.data.sasUrl) {
          resolve(response.data.sasUrl);
          console.log("✅ Recording URL retrieved successfully:", response.data.sasUrl);
        } else {
          resolve(null);
        }
      })
      .catch((error) => {
        resolve();
      });
  });
};

// Service to get blob access token for an agent
export const getBlobAccessToken = (tenantId, agentScope, recordingScope, userId) => {
  return new Promise((resolve) => {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/Callrecordingsaccess/${tenantId}/${agentScope}/${recordingScope}?userid=${userId}`;
    axios.get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        resolve();
      });
  });
};


// ------------------ PORTAL SETTINGS MANAGEMENT ------------------

export async function getPortalSettings(tenantId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/PortalSettingsManagement/${tenantId}/get?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });

    if (response.data?.success) {
      return {
        success: true,
        data: response.data.data
      };
    }

    return {
      success: false,
      data: null,
      message: response.data?.message || 'Failed to get portal settings'
    };
  } catch (error) {
    console.error('Error getting portal settings:', error);
    return {
      success: false,
      data: null,
      message: error.message
    };
  }
}
export async function addPortalSettings(tenantId, portalSettings, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/PortalSettingsManagement/${tenantId}/add?token=${token}`;
    const response = await axios.post(url, portalSettings, { headers: getHeaders(token) });

    if (response.data?.success) {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Settings added successfully'
      };
    }

    return {
      success: false,
      message: response.data?.message || 'Failed to add settings'
    };
  } catch (error) {
    console.error('Error adding portal settings:', error);
    return {
      success: false,
      message: error.message
    };
  }
}


export async function updatePortalSettings(tenantId, portalSettings, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/PortalSettingsManagement/${tenantId}/default/update?token=${token}`;
    const response = await axios.post(url, portalSettings, { headers: getHeaders(token) });

    if (response.data?.success) {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Settings updated successfully'
      };
    }

    return {
      success: false,
      message: response.data?.message || 'Failed to update settings'
    };
  } catch (error) {
    console.error('Error updating portal settings:', error);
    return {
      success: false,
      message: error.message
    };
  }
}
// ------------------ VARIABLES (CustomerDB) ------------------
export async function getAllVariables(tenantId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CustomerDBManagement/${tenantId}/${scope}/get/ALL?token=${token}`;
   
    const response = await axios.get(url, { headers: getHeaders(token) });

    return response.data?.success ? response.data.data : [];
  } catch (e) {
    console.error("Error fetching variables:", e);
    return [];
  }
}
export async function getVariable(tenantId, scope, variableId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CustomerDBManagement/${tenantId}/${scope}/get/${variableId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });

    return response.data?.success ? response.data.data : null;
  } catch (e) {
    console.error("Error fetching variable:", e);
    return null;
  }
}

export async function createVariable(tenantId, scope, variableData, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CustomerDBManagement/${tenantId}/${scope}/create/null?token=${token}`;
    const response = await axios.post(url, variableData, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error creating variable:", e);
    return { success: false, message: e.response?.data?.message || "Error creating variable" };
  }
}

export async function updateVariable(tenantId, scope, variableId, variableData, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CustomerDBManagement/${tenantId}/${scope}/update/${variableId}?token=${token}`;
    const response = await axios.post(url, variableData, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error updating variable:", e);
    return { success: false, message: e.response?.data?.message || "Error updating variable" };
  }
}

export async function deleteVariable(tenantId, scope, variableId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/CustomerDBManagement/${tenantId}/${scope}/remove/${variableId}?token=${token}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error deleting variable:", e);
    return { success: false, message: e.response?.data?.message || "Error deleting variable" };
  }
}

// ------------------ WORKFLOWS ------------------
export async function getAllWorkflows(tenantId, scope, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/workflowManagement/${tenantId}/${scope}/get/ALL?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data?.success ? response.data.data : [];
  } catch (e) {
    console.error("Error fetching workflows:", e);
    return [];
  }
}

export async function getWorkflow(tenantId, scope, workflowId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/workflowManagement/${tenantId}/${scope}/get/${workflowId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data?.success ? response.data.data : null;
  } catch (e) {
    console.error("Error fetching workflow:", e);
    return null;
  }
}

export async function createWorkflow(tenantId, scope, workflowData, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/workflowManagement/${tenantId}/${scope}/create/null?token=${token}`;
    const response = await axios.post(url, workflowData, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error creating workflow:", e);
    return { success: false, message: e.response?.data?.message || "Error creating workflow" };
  }
}

export async function updateWorkflow(tenantId, scope, workflowId, workflowData, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/workflowManagement/${tenantId}/${scope}/update/${workflowId}?token=${token}`;
    const response = await axios.post(url, workflowData, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error updating workflow:", e);
    return { success: false, message: e.response?.data?.message || "Error updating workflow" };
  }
}

export async function deleteWorkflow(tenantId, scope, workflowId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/workflowManagement/${tenantId}/${scope}/remove/${workflowId}?token=${token}`;
    const response = await axios.post(url, {}, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error deleting workflow:", e);
    return { success: false, message: e.response?.data?.message || "Error deleting workflow" };

  }
}

// ------------------ AGENT PERFORMANCE ------------------
export async function getMyAgentProfile(tenantId, userId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/MyAgentProfile/${tenantId}/${userId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });

    return response.data;
  } catch (e) {
    console.error("Error fetching agent profile:", e);
    return null;
  }
}

export async function getAgentConnectedCalls(tenantId, agentId, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/GetAgentConnectedCalls/${tenantId}/${agentId}?token=${token}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    return response.data;
  } catch (e) {
    console.error("Error fetching agent connected calls:", e);
    return null;
  }
}

export async function getAgentInformation(tenantId, profileScope, agentId, tz, tasks, token) {
  try {
    const url = `${HEEDIFY_PROVIONONG_PATH_V2}/AgentPerformance/${tenantId}/${profileScope}/${agentId}?tz=${tz}&tasks=${tasks}`;
    const response = await axios.get(url, { headers: getHeaders(token) });
    console.log("Agent information response:", response.data);
    return response.data;
  } catch (e) {
    console.error("Error fetching agent information:", e);
    return null;
  }
}

